import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {flightTrackerPagesList_template} from "../components/templates/flightTrackerPagesList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class flight_tracker_page extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected flightTrackerPagesList: flightTrackerPagesList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.flightTrackerPagesList = new flightTrackerPagesList_template("flightTrackerPagesList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Flight Tracker Pages");
        return [this.flightTrackerPagesList.build()];
    }

    protected getModuleName(): string {
        return "flight_tracker_page";
    }

    fillPage() {
        this.getFlightTrackerPageData();
    }

    protected getFlightTrackerPageData() {
        this.loadingIn(this.flightTrackerPagesList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.flightTrackerPagesList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/flight-tracker-pages/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetFlightTrackerPageDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetFlightTrackerPageDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount;
                let totalPage = responseParsed.totalPage;
                let pages = responseParsed.data;

                obj.viewModel.flightTrackerPagesList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100;

                obj.flightTrackerPagesList.setResultInfo(totalCount, totalPage, execTime);
                obj.flightTrackerPagesList.setFlightTrackerPages(pages, obj.getBrandId());

                if (responseParsed.extraData && responseParsed.extraData.defaultThreshold) {
                    obj.flightTrackerPagesList.setDefaultThreshold(responseParsed.extraData.defaultThreshold);
                }
            });
            obj.loadingOut(obj.flightTrackerPagesList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected flightTrackerPagesListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getFlightTrackerPageData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getFlightTrackerPageData();
    }

    protected filterMultipleSelectorOnChange() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.viewModel.flightTrackerPagesList.pagination.pageNumber(1);
        this.getFlightTrackerPageData();
    }

    protected filterSimpleOnChange() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.viewModel.flightTrackerPagesList.pagination.pageNumber(1);
        this.getFlightTrackerPageData();
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    public viewOnWebsite(permalink: string) {
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if (url.length == 3) {
            if (url[0] != "emakicms") {
                // QA override: the flight-tracker site feature is deployed on qa5,
                // while emaki runs on qa2. Remap so links target qa5.simpleflying.com.
                let subdomain = url[0] === "qa2" ? "qa5" : url[0];
                urlBegin += subdomain + ".";
            } else {
                isLocal = true;
            }
        }

        for (let i = 0; i < userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {
                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + (isLocal ? ("." + url[2]) : "") + permalink, "_blank")
                break;
            }
        }
    }

    protected viewPage(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/flight-tracker-pages/edit/' + id + '/')
    }

    protected addPage() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/flight-tracker-pages/add/')
    }

    protected deletePage(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/flight-tracker-pages/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.flightTrackerPagesList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Flight tracker page <strong>" + responseParsed.data.permalink + "</strong> was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getFlightTrackerPageData()
                })
                obj.loadingOut(obj.flightTrackerPagesList.builtTemplate.children.namedItem("list-results"));
            }
        });
        XHRHdl.execute();
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }
}



// WEBPACK FOOTER //
// ./js/modules/flight_tracker_page.ts